import { Form, Input } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { generateRules } from "utils/helperFunctions";

const IbarFullName = ({ item }) => {
  //Dependencies
  const {
    selectedLanguage,
    widgetJSON: { data },
  } = useSelector((state) => state);

  // Statics
  const splitedPleaceHolder = item.placeholder[selectedLanguage].split(" ");
  const rules =
    generateRules({
      component: item,
      errors: data.general_settings.error_messages,
      selectedLanguage: selectedLanguage,
    }) || [];

  return (
    <div className="padding ibar_full_name">
      <Form.Item rules={[...rules]} name={["customer_data", "ibar_name"]}>
        <Input type="text" placeholder={splitedPleaceHolder[0]} />
      </Form.Item>
      <Form.Item rules={[...rules]} name={["customer_data", "ibar_lastname"]}>
        <Input type="text" placeholder={splitedPleaceHolder[1]} />
      </Form.Item>
    </div>
  );
};

export default IbarFullName;
